export var TableEvent;
(function (TableEvent) {
    TableEvent["SetSelected"] = "tc-table-set-selected";
    TableEvent["SelectedChanged"] = "tc-table-selected-changed";
})(TableEvent || (TableEvent = {}));
